// extracted by mini-css-extract-plugin
export default {"risk-title":"_risk-title_P8wnnu","score":"_score_odrxg3"};